import React, { useCallback, useRef, useEffect } from "react";
import {
  FocusContext,
  useFocusable,
} from "@noriginmedia/norigin-spatial-navigation";
import { BackBarButtonMini } from "../../common/backBarButton";
import { MoviesSlider } from "./categoryList";
import smoothScroll from "../../../utils/animateScroll";
import { getVerticalFocusScrollTarget } from "../../../utils/focusScroll";
import { useInputMode } from "../../../utils/hooks/useInputMode";

// ============================================================================
// MAIN COMPONENT
// ============================================================================

var GridContent = function (props) {
  const { data, title, onLoadMore, hasMore, isLoading } = props;
  var { ref, focusKey } = useFocusable();
  var innerRef = useRef(null);
  var sentinelRef = useRef(null);
  var { isMouseFocus } = useInputMode();

  var onRowFocus = useCallback(
    function (focusProps) {
      if (isMouseFocus) return;
      var targetScroll = getVerticalFocusScrollTarget(ref.current, focusProps || {}, {
        topPadding: 88,
        bottomPadding: 128,
      });
      smoothScroll(ref, targetScroll, 500);
    },
    [ref, isMouseFocus]
  );

  // IntersectionObserver for infinite scroll
  useEffect(
    function () {
      var observer = new IntersectionObserver(
        function (entries) {
          var entry = entries[0];
          if (entry.isIntersecting && hasMore && !isLoading && onLoadMore) {
            onLoadMore();
          }
        },
        { root: ref.current, threshold: 1.0 }
      );

      var sentinel = sentinelRef.current;
      if (sentinel) {
        observer.observe(sentinel);
      }

      return function () {
        if (sentinel) {
          observer.unobserve(sentinel);
        }
      };
    },
    [hasMore, isLoading, onLoadMore, ref]
  );

  return (
    <div className="legacy-anavatan-grid-wrapper">
      <div className="legacy-anavatan-grid-inner">
        <FocusContext.Provider value={focusKey}>
          <div className="legacy-anavatan-grid-scroll" ref={ref}>
            <div>
              <div className="legacy-anavatan-grid-header-row">
                <div className="legacy-anavatan-grid-header-cell">
                  <BackBarButtonMini />
                  <h4 className="legacy-anavatan-grid-title">{title}</h4>
                </div>
              </div>
              <div className="legacy-anavatan-grid-content" ref={innerRef}>
                {data && data.length > 0 ? (
                  <MoviesSlider
                    movies={data}
                    onFocus={onRowFocus}
                  />
                ) : (
                  <div className="legacy-anavatan-grid-empty">
                    <p>محتوایی یافت نشد</p>
                  </div>
                )}
                <div className="legacy-anavatan-grid-sentinel" ref={sentinelRef} />
                {isLoading && (
                  <div className="legacy-anavatan-grid-loading">
                    <span>در حال بارگذاری...</span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </FocusContext.Provider>
      </div>
    </div>
  );
};

export default GridContent;

